import React, { useEffect } from "react";
import { navigate } from "gatsby";
let isScriptLoaded = false;

import { CURRENT_COUNTRY } from "utils/constants";

const QuizSection = ({ data }) => {
	console.log(CURRENT_COUNTRY);
	useEffect(() => {
		window.addEventListener("octane.quiz.completed", (event) => {
			const mainGoalAnswer = event.detail.answers["Octane: What is your main goal?"];

			const getRedirectUrl = () => {
				if (CURRENT_COUNTRY === "de") {
					switch (mainGoalAnswer) {
						case "Support Muscle Growth":
							return "/products/protein-bundle";
						case "Lose Weight":
							return "/products/light-bundle";
						case "Eat Healthier":
						case "Become Vegan/Eat More Vegan Food":
						case "Save Time":
						case "Other":
							return "/products/healthy-habits-bundle";
						case "Improve Gut Health":
						case "Postpartum Nutrition":
							return "/products/guthealth-bundle";
						default:
							return "/products/healthy-habits-bundle";
					}
				} else if (CURRENT_COUNTRY === "nl") {
					switch (mainGoalAnswer) {
						case "Support Muscle Growth":
							return "/products/protein-bundle";
						case "Lose Weight":
							return "/products/light-bundle";
						case "Eat Healthier":
						case "Become Vegan/Eat More Vegan Food":
						case "Save Time":
						case "Other":
							return "/products/healthy-habits-bundle";
						case "Improve Gut Health":
						case "Postpartum Nutrition":
							return "/products/guthealth-bundle";
						default:
							return "/products/healthy-habits-bundle";
					}
				} else if(CURRENT_COUNTRY === "ch") {
					switch (mainGoalAnswer) {
						case "Support Muscle Growth":
							return "/products/protein-bundle";
						case "Lose Weight":
							return "/products/light-bundle";
						case "Eat Healthier":
						case "Become Vegan/Eat More Vegan Food":
						case "Save Time":
						case "Other":
							return "/products/healthy-habits-bundle";
						case "Improve Gut Health":
						case "Postpartum Nutrition":
							return "/products/guthealth-bundle";
						default:
							return "/products/healthy-habits-bundle";
					}
				}
			};

			window.dataLayer.push({ event: "octane_quiz_completed" });
			navigate(getRedirectUrl());
		});

		if (!isScriptLoaded) {
			// Ensure the script is loaded only once
			const script = document.createElement("script");
			script.src = `https://app.octaneai.com/${data.script_src_id}/quiz.js`;
			script.async = true;
			script.defer = true;
			document.body.appendChild(script);

			isScriptLoaded = true;

			return () => {
				// Clean up the script when the component unmounts
				document.body.removeChild(script);
				isScriptLoaded = false;
			};
		}
	}, []);

	return (
		<>
			<div
				className="octane-ai-quiz"
				data-quiz-id={data?.id}
				data-embed-type="fullpage"
				data-mobile-height="match_browser"
				data-desktop-height="match_browser"
			></div>
		</>
	);
};

export default QuizSection;
